module.exports = __webpack_public_path__ + "28b67065/img/link-icon.fa09ed66.svg";